import { Navigate, useLocation } from "react-router-dom";
import { useAuthStore, useHasHydrated } from "@/stores/authStore";
import { AUTH_ROUTES } from "../constants";
import { Loader2 } from "lucide-react";

interface ProtectedRouteProps {
  children: React.ReactNode;
}

/**
 * Route guard that redirects to login if user is not authenticated.
 * Preserves the original destination for redirect after login.
 */
export function ProtectedRoute({ children }: ProtectedRouteProps) {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);
  const hasHydrated = useHasHydrated();
  const location = useLocation();

  // Show loading while hydrating from localStorage
  if (!hasHydrated) {
    return (
      <div className="flex h-screen items-center justify-center">
        <Loader2 className="text-primary h-8 w-8 animate-spin" />
      </div>
    );
  }

  // Redirect to login if not authenticated
  if (!isAuthenticated) {
    return <Navigate to={AUTH_ROUTES.LOGIN} state={{ from: location }} replace />;
  }

  return <>{children}</>;
}
